import React from "react";
import "./HousekeepingServices.css";

// 👉 Replace with your own small icon
import ServiceIcon from "../../Image/HouseKeeping/rightthick.png";

const services = [
  "Pre-event setup cleaning",
  "Venue preparation & sanitization",
  "On-event cleaning support",
  "Washroom maintenance during events",
  "Refreshment area cleaning",
  "Trash removal & management",
  "Floor cleaning & spot treatment",
  "Post-event deep cleaning",
  "Furniture arrangement support",
  "Exhibition booth cleaning",
  "Conference hall maintenance",
  "Quick-response spill management",
 
];

const steps = [
  {
    number: "01",
    title: "Event Planning",
    desc: "Understand event type, venue, timeline, and specific cleaning requirements.",
  },
  {
    number: "02",
    title: "Pre-Event Setup",
    desc: "Complete venue cleaning, sanitization, and preparation before guests arrive.",
  },
  {
    number: "03",
    title: "During Event Support",
    desc: "Provide discreet, continuous cleaning support throughout the event duration.",
  },
  {
    number: "04",
    title: "Post-Event Restoration",
    desc: "Thorough cleaning and restoration of venue to original or better condition.",
  },
];

const EventCleaningServices = () => {
  return (
    <>
      {/* ---------------- SERVICES SECTION ---------------- */}
      <section className="hk-services-section">
        <h2 className="hk-section-title">Our Service Includes</h2>

        <div className="hk-services-grid">
          {services.map((item, index) => (
            <div key={index} className="hk-service-card">
              <img src={ServiceIcon} alt="service" className="hk-service-img" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------- PROCESS SECTION ---------------- */}
      <section className="hk-process-section">
        <div className="hk-process-tag">Our Process</div>
        <h2 className="hk-section-title">Our Event Cleaning Process</h2>

        <div className="hk-process-grid">
          {steps.map((step, index) => (
            <div key={index} className="hk-process-card">
              <div className="hk-process-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default EventCleaningServices;
